import { brands } from '@/mocks/homeMock';

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-600">
              <i className="ri-emotion-happy-line" />
              WHY US
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">吃瓜也要讲效率</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              信息爆炸的时代，真正的痛点不是“瓜少”，而是“瓜太多却看不到重点”。
              <span className="font-semibold text-foreground-900">吃瓜最快</span>定位为全网热点竞速情报站，
              用速度排行与时效比拼帮你在海量信息中快速锁定最重要的那一个。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们相信：快，不代表冲动。每一篇抢先报道都会标注信源与可信度，
              让速度与理性并存，让每一次吃瓜都更有价值。
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <a href="#hot" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition hover:bg-primary-400">
                立即去看今日热榜
                <i className="ri-arrow-right-line" />
              </a>
              <a href="#faq" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 ring-1 ring-background-200 transition hover:bg-background-200">
                了解更多
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {brands.map((b) => (
              <div key={b.name} className="rounded-2xl border border-background-200 bg-background-50 p-5 transition hover:border-accent-300">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                  <i className={`${b.icon} text-lg`} />
                </span>
                <h3 className="mt-3 text-base font-bold text-foreground-950">{b.name}</h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}